export default __webpack_public_path__ + "ba7f70b3e91cdc7cedd0ddf8cb45f3ae.png";